import React, { useCallback, useEffect, useState } from 'react';
import { Layout, message } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { TextPageContent } from '../../organisms/text';
import { GRAPHICS } from '../../../constants/define/translation';
import { appStyles } from '../../../styles';
import { getTextsRepository } from '../../../repository/mytm/text/textRepository';
import { MESSAGE_ERROR } from '../../../constants/message';
import { TextsTable } from '../../organisms/graphics/TextsTable';
import { CreateTextModal } from './graphics/text-graphic/form/CreateTextModal';
import { IconCreateBlack } from '../../../assets';

const { Content } = Layout;

export const TextAssets = () => {
  const { t } = useTranslation(GRAPHICS);
  const [listTexts, setListTexts] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<any>(false);
  // Modal
  const [currentRecord, setCurrentRecord] = useState<any>();
  const [isOpenTextModal, setIsOpenCreateTextModal] = useState(false);

  const handleGetTexts = useCallback(async (loading?: boolean) => {
    try {
      setIsLoading(true);
      const texts = await getTextsRepository();
      if (texts.length === 0) {
        setListTexts([]);
        setIsLoading(false);
        return;
      }
      const data = texts.map((item, index) => ({
        index,
        ...item,
      }));

      setListTexts(data);
      setIsLoading(false);
    } catch (e) {
      setListTexts([]);
      setIsLoading(false);
      message.error(MESSAGE_ERROR.M03);
    }
  }, []);

  const onLoading = useCallback((loading: boolean) => {
    setIsLoading(loading);
  }, []);

  const onOpenCreateTextModal = useCallback(() => {
    setIsOpenCreateTextModal(true);
  }, []);

  const onCloseImageModal = useCallback(() => {
    setIsOpenCreateTextModal(false);
    setCurrentRecord(null);
  }, []);

  const onHandleClickBtnEdit = useCallback((record: any) => {
    setCurrentRecord(record);
    setIsOpenCreateTextModal(true);
  }, []);

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('btnCreate'),
      bgWhite: 'true',
      onClick: onOpenCreateTextModal,
      icon: <IconCreateBlack />,
    },
  ];

  useEffect(() => {
    handleGetTexts();
  }, []);
  return (
    <>
      <Container>
        <Content>
          <ContentPageHeader title={t('title.textPageTitle')} extra={extra} />
          <TextsTable
            records={listTexts}
            onHandleClickBtnEdit={onHandleClickBtnEdit}
            onRefresh={handleGetTexts}
            onLoading={onLoading}
            loading={isLoading}
          />
          <CreateTextModal
            isOpenModal={isOpenTextModal}
            onClose={onCloseImageModal}
            record={currentRecord}
            onRefresh={handleGetTexts}
          />
          <TextPageContent />
        </Content>
      </Container>
    </>
  );
};

const Container = styled.div`
  ${appStyles.paddingComponent}
`;
